import { BaseResourceModel, EventoContabil, Exercicio, Orgao, PlanoConta } from 'eddydata-lib';

export class GrupoEstoqueContabilPlano extends BaseResourceModel {
    constructor(
        public id?: number,
        public plano_conta?: PlanoConta,
        public ficha_variacao?: EventoContabil,
        public exercicio?: Exercicio,
        public orgao?: Orgao,
    ) {
        super()
    }

    static converteJson(json: any): GrupoEstoqueContabilPlano {
        return Object.assign(new GrupoEstoqueContabilPlano(), json)
    }
}
